<template>
  <div>
    <img class="template-default-img" :src="url" alt="">
  </div>
</template>

<script>
export default {
  name: 'scenario_item_image',
  props: [
    'url'
  ]
}
</script>

<style scoped>
  .template-default-img {
    width: 100%;
    border-radius: 20px 20px 0 0;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/scenario/item/scenario_item_image.vue